module.exports = __webpack_public_path__ + "img/yilingqu.8da3b6b4.png";